import { EventEmitter } from '@angular/core';
import { FormMode } from '../constants';
var FormCoreComponent = /** @class */ (function () {
    function FormCoreComponent() {
        this.FormMode = FormMode;
        this.submitted = new EventEmitter();
        this.mode = FormMode.CREATE;
        this._disabled = false;
        this._loading = false;
    }
    Object.defineProperty(FormCoreComponent.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (val) {
            this._disabled = val;
            if (this._disabled) {
                this.form.disable();
            }
            else {
                this.form.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormCoreComponent.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        set: function (val) {
            this._loading = val;
            if (this._loading && !this.form.disabled) {
                this.form.disable();
            }
            else if (!this._loading && !this._disabled) {
                this.form.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    FormCoreComponent.prototype.onSubmit = function () {
        if (this.form.valid && !this.loading) {
            this.submitted.emit(this.form.value);
        }
        else {
            for (var control in this.form.controls) {
                this.form.controls[control].markAsTouched();
            }
        }
    };
    return FormCoreComponent;
}());
export { FormCoreComponent };
